module.exports = __webpack_public_path__ + "static/media/artDay.f60aaca2.png";